import { render, staticRenderFns } from "./PollOption.vue?vue&type=template&id=70577ad2&"
import script from "./PollOption.vue?vue&type=script&lang=ts&"
export * from "./PollOption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports